import { render, staticRenderFns } from "./DialogPage.vue?vue&type=template&id=482969fb"
import script from "./DialogPage.vue?vue&type=script&lang=js"
export * from "./DialogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports